// extracted by mini-css-extract-plugin
export var disabled = "_16-a";
export var hierarchyLinkGray = "_16-4";
export var hierarchyLinkUnderline = "_16-3";
export var hierarchyPrimary = "_16-0";
export var hierarchySecondary = "_16-1";
export var hierarchyTertiary = "_16-2";
export var pressed = "_16-6";
export var themeAction = "_16-5";
export var themeDestructive = "_16-8";
export var themeNormal = "_16-7";
export var themeSuccess = "_16-9";